import {
    HealthCheckerCheck,
    HealthCheckerCheckRequest,
} from "../../../../../models/health-checker/health-checker";
import {HealthCheckerCheckFormValues} from "./checks.types";

export const healthCheckerCheckToFormValues = (
    check: HealthCheckerCheck | null
): Partial<HealthCheckerCheckFormValues> => {
    if (!check) {
        return {};
    }

    return {
        checkerName: check.checkerName,
        group: check.group.id,
        hours: check.hours,
    };
};

export const healthCheckerCheckFormToRequest = (
    values: HealthCheckerCheckFormValues
): HealthCheckerCheckRequest => ({
    checkerName: values.checkerName,
    group: values.group,
    hours: values.hours,
});
